module.exports = __webpack_public_path__ + "img/zhengzhao.679482b2.png";